import axios from "axios";
import qs from "qs";
import { version } from "../config/Api";

/**
 * Base Axios Instance for primary CMS API
 */
const api = axios.create({
    baseURL: "https://tanin.com.bd/admin/index.php/api/" + version,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    },
});

/**
 * Request Interceptor for adding Auth tokens
 */
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.AuthorizationHeader = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

/**
 * Generic API Handlers
 */
export const get = (url, params = {}) => api.get(url, { params });
export const post = (url, data = {}) => api.post(url, qs.stringify(data));


export default api;
